import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { GetConfigResponse } from '../interfaces/get-config';
import { GetInfoResponse, Info } from '../interfaces/get-info';

export interface ReportState {
  config: any[];
  info: Info | null;
  errorCode: number | null;
}

const initialState: ReportState = {
  config: [],
  info: null,
  errorCode: null,
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    getConfigInitApiAction: (state) => {
      state.errorCode = null;
    },
    getConfigSuccessApiAction: (state, action: PayloadAction<GetConfigResponse>) => {
      state.config = action.payload.config;
    },
    getConfigFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getInfoInitApiAction: (state) => {
      state.errorCode = null;
    },
    getInfoSuccessApiAction: (state, action: PayloadAction<GetInfoResponse>) => {
      state.info = action.payload.info;
    },
    getInfoFailureApiAction: (state,action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postConfigInitApiAction: () => {},
    postConfigSuccessApiAction: () => {},
    postConfigFailuireApiAction: () => {},
    deleteConfigInitApiAction: () => {},
    deleteConfigSuccessApiAction: () => {},
    deleteConfigFailuireApiAction: () => {},
    getDownloadFileInitApiAction: (state) => {
      state.errorCode = null;
    },
    getDownloadFileSuccessApiAction: () => {},
    getDownloadFileFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postGeneratedFileInitApiAction: () => {},
    postGeneratedFileSuccessApiAction: () => {},
    postGeneratedFileFailuireApiAction: () => {},
    reportClearAction: (state) => {
      state.config = [];
      state.info = null;
      state.errorCode = null;
    },
  },
});

export const {
  getConfigInitApiAction,
  getConfigSuccessApiAction,
  getConfigFailureApiAction,
  postConfigInitApiAction,
  postConfigSuccessApiAction,
  postConfigFailuireApiAction,
  deleteConfigInitApiAction,
  deleteConfigSuccessApiAction,
  deleteConfigFailuireApiAction,
  getInfoInitApiAction,
  getInfoSuccessApiAction,
  getInfoFailureApiAction,
  getDownloadFileInitApiAction,
  getDownloadFileSuccessApiAction,
  getDownloadFileFailureApiAction,
  postGeneratedFileInitApiAction,
  postGeneratedFileSuccessApiAction,
  postGeneratedFileFailuireApiAction,
  reportClearAction,
} = reportSlice.actions;

export default reportSlice.reducer;
